import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronDown } from "lucide-react";
import { PortfolioItem } from "@/hooks/profile";
import ProjectImagesManager from "../components/ProjectImagesManager";

interface ShotImagesCardProps {
  item: PortfolioItem;
  onChange: (updatedItem: PortfolioItem) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onUploadStatusChange?: (isUploading: boolean) => void;
}

export const ShotImagesCard: React.FC<ShotImagesCardProps> = ({
  item,
  onChange,
  isCollapsed,
  onToggleCollapse,
  onUploadStatusChange,
}) => {
  return (
    <Card className="mb-6">
      <CardHeader
        className="cursor-pointer hover:bg-gray-50/50 transition-colors"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-base text-gray-500">Shot Images</CardTitle>
          <ChevronDown
            className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${
              isCollapsed ? '' : 'rotate-180'
            }`}
          />
        </div>
      </CardHeader>
      {!isCollapsed && (
        <CardContent className="space-y-4">
          <ProjectImagesManager
            item={item}
            onChange={onChange}
            onUploadStatusChange={onUploadStatusChange}
          />
        </CardContent>
      )}
    </Card>
  );
};
